import { render, staticRenderFns } from "./RsaConfigurazioneDizionarioModalEditComponent.vue?vue&type=template&id=1867582a"
import script from "./RsaConfigurazioneDizionarioModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneDizionarioModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports